import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import {
  Popover, Badge, Icon as AntIcon, Button, Tooltip,
} from 'antd'
import _ from 'lodash'
import {
  Loading, Div, SmallText, Icon, P,
} from 'konsys-ui'
import { EachNoti, ShowAll } from './styled'
import {
  removeAccessToken, removeRefreshToken, getURL, getLocalStorage,
} from '../../utils/local-data-service'
import { GET_NOTI } from '../../constants/graphql/query'
import { convertModule } from '../../pages/notification-page'

export default () => {
  const logout = () => {
    removeAccessToken()
    removeRefreshToken()
    window.location = `${getURL().WEB_CMS_SERVER}/login`
  }
  return (
    <Div style={{ float: 'right' }} margin='0 24px 0 0'>
      <Div display='flex' flexDirection='row' alignItems='center'>
        <SmallText bold style={{
          width: '38vw', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'right',
        }}>{getLocalStorage('fullname')}</SmallText>
        {/* <Query
          query={GET_NOTI}
          fetchPolicy='network-only'
          variables={{
            limit: 5,
          }}
          pollInterval={300000}
        >
          {
            ({
              loading, data, error, refetch,
            }) => {
              if (loading && _.isEmpty(data)) return <AntIcon style={{ marginLeft: 8 }} type="loading" spin />
              if (error) return <P>เกิดข้อผิดพลาด</P>

              return (
                <Div display='flex' flexDirection='column' alignItems='flex-end'>
                  <Div display='flex' flexDirection='row' margin="0 0 0 12px">
                    <Popover
                      trigger="click"
                      placement="bottomRight"
                      content={
                        <Div display='flex' flexDirection='column'>
                          {
                            loading && _.isEmpty(data)
                              ? <Loading/>
                              : error
                                ? <P>เกิดข้อผิดพลาด</P>
                                : !_.isEmpty(data.showAllNoti.notiUnread)
                                  ? _.map(data.showAllNoti.notiUnread, (v, i) => (
                                    <Link
                                      key={i}
                                      to={`/${convertModule(v.mainModule)}/view/${_.split(_.split(_.split(v.message, '(')[1], ' ')[1], ')')[0]}`}
                                    >
                                      <EachNoti read={v.read}>{v.message}</EachNoti>
                                    </Link>))
                                  : <P margin='16px'>ไม่มีรายการแจ้งเตือนที่ไม่ได้อ่าน</P>
                          }
                          <Link to='/notification'><ShowAll>ดูทั้งหมด</ShowAll></Link>
                        </Div>
                      }
                    >
                      {
                        data && data.showAllNoti && <Badge count={data.showAllNoti.countUnread} style={{ fontSize: '10px', padding: '0 4px' }}>
                          <Icon icon="fas fa-bell" fontSize="24px" cursor='pointer' onClick={() => refetch()} />
                        </Badge>
                      }
                    </Popover>
                  </Div>
                </Div>
              )
            }}
        </Query> */}
        {/* <Button onlyIcon icon='far fa-sign-out' margin='0 0 0 24px' onClick={() => logout()}/> */}
        <Tooltip placement="bottomRight" title='ออกจากระบบ'>
          <Button shape="circle" icon="logout" style={{ margin: '0 0 0 16px' }} onClick={() => logout()}/>
        </Tooltip>
      </Div>
    </Div>
  )
}
